export const EMAIL_SUPORTE_AGNES =
  import.meta.env.VITE_APP_SUPORTE_AGNES || 'seusucesso@agnes.com.br';

export const MSG_ERRO_EXPORTACAO = `Não foi possível processar sua solicitação de exportação. Por favor, tente novamente mais tarde. Se o problema persistir, entre em contato com o ${EMAIL_SUPORTE_AGNES}.`;
